'use-strict';

const moment = require('moment');
const random = require('random-seed');

const DATE_FRONTEND_FORMAT = 'DD.MM.YYYY';
const DATE_BACKEND_FORMAT = 'YYYY-MM-DD HH:mm:ss';

/* @ngInject */
export class NumberConversionService {
  constructor($rootScope, $location, constantsService, dateService) {
    'ngInject';

    this.$rootScope = $rootScope;
    this.$location = $location;
    this.constantsService = constantsService;
    this.dateService = dateService;
  }

  generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      // eslint-disable-next-line no-bitwise, no-mixed-operators
      const r = Math.random() * 16 | 0;
      // eslint-disable-next-line no-bitwise, no-mixed-operators
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  public calculateVat = (
    value: number,
    includeVat: boolean,
    vatRate?: number | undefined,
  ): number => {
    const vat = (vatRate || 0.19) + 1;

    if (includeVat) return Number((value * vat).toFixed(2));
    return Number((value / vat).toFixed(2));
  };

  public calculatePriceWithTax = (
    basePrice: number,
    vatRate: number,
  ): string => (basePrice * (1 + vatRate)).toFixed(2);

  randomNumberWithSeed(seed, maxInt) {
    const generator = random.create(seed);
    return generator.intBetween(0, maxInt);
  }

  public convertFloatToFrontend = (float: number, ceil?: boolean): string => {
    if (!ceil) return String(float).replace('.', ',');
    return String(Math.round(float)).replace('.', ',');
  };

  public convertFloatToBackend = (float: string | number): number => parseFloat(String(float).replace(',', '.'));

  /**
   * Converts all float keys of object to different notation.
   *
   * @param {object} object
   * @param {Array <string>} keys
   * @param {string} mode define conversion to backend or frontend
   * @returns {object}
   */
  convertFloatValuesOfObject(object, keys, mode) {
    for (const floatColumn of keys) {
      if (object[floatColumn] !== undefined) {
        let convertedFloat = object[floatColumn];

        switch (mode) {
          case 'frontend':
            convertedFloat = this.convertFloatToFrontend(convertedFloat);
            break;
          case 'backend':
            convertedFloat = this.convertFloatToBackend(convertedFloat);
            break;
          default:
            break;
        }
        object[floatColumn] = convertedFloat;
      }
    }
    return object;
  }

  /**
   * Parse a date from frontend format and convert it to backend format.
   *
   * @param {String} date
   */
  parseDate(date) {
    if (date === null) return null;
    return moment(date, DATE_FRONTEND_FORMAT).format(DATE_BACKEND_FORMAT);
  }

  public frontendStringToDate = (date: string | null): Date => {
    if (date === null) return new Date();
    return moment(date, DATE_FRONTEND_FORMAT).toDate();
  };

  /**
   * Parse a String number to a float
   *
   * @param {String} number
   */
  public parseStringFloat = (number: string | number): number => {
    if (typeof number === 'number') return number;
    return parseFloat(String(number).replace('.', '').replace(',', '.'));
  };

  /** Parse a float value to string and replace decimal points to German format. */
  public floatToLocalizedString = (f: number): string => String(f).replace('.', ',');
}

export default angular.module('services.numberConversionService', [])
  .service('numberConversionService', NumberConversionService)
  .name;
